import {svgIconWrapper} from '../svg-icon-wrapper';

import UncommonGivingRegular from './uncommon-giving-regular-icon.svg';

function SvgComponent(props: React.SVGProps<SVGSVGElement>) {
    return <UncommonGivingRegular {...props} />;
}

SvgComponent.iconName = 'uncommonGivingRegular';

export const UncommonGivingRegularIcon = svgIconWrapper(SvgComponent);
